(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(9183);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4260:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);



/* harmony default export */ __webpack_exports__["Z"] = (()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "bg-cover bg-center bg-no-repeat overflow-hidden text-white",
        style: {
            backgroundColor: "#262628"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container mx-auto px-10 py-20",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "md:grid grid-cols-4 gap-10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-2",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex-1 mb-20 text-[18px] leading-[30px]",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/",
                                    title: "Facture",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: "/images/facture-logo-white.svg",
                                        alt: "Facture Logo",
                                        width: "130",
                                        height: "28",
                                        className: "mb-10"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "mb-6",
                                    children: "Accelerating the transition towards online, aggregated, and always up-to-date catalogues raisonn\xe9s."
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "text-[16px] max-md:hidden",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "All artworks \xa9 the artists."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            children: [
                                                "\xa9 ",
                                                new Date().getFullYear(),
                                                " All Rights Reserved. Artwishlist Ltd."
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-span-1 mt-16",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mb-10",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "mb-2 text-[#919191] uppercase",
                                    children: "Menu"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: "text-sm space-y-1.5",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/#artwork-timeline",
                                                scroll: false,
                                                className: "hover:underline",
                                                children: "Artwork Timeline"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/#search",
                                                scroll: false,
                                                className: "hover:underline",
                                                children: "Search"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/#image-recognition",
                                                scroll: false,
                                                className: "hover:underline",
                                                children: "Image recognition"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/#editing",
                                                scroll: false,
                                                className: "hover:underline",
                                                children: "Editing"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "https://search.facture.art/",
                                                className: "hover:underline",
                                                children: "Sign up"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "mt-8 mb-2 text-[#919191] uppercase",
                                    children: "Information"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: "text-sm space-y-1.5",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/terms-and-conditions",
                                                className: "hover:underline",
                                                children: "Terms and Conditions"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/privacy-policy",
                                                className: "hover:underline",
                                                children: "Privacy Policy"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "col-span-1 mt-16",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mb-10",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "mb-2 text-[#919191] uppercase",
                                        children: "Contact us"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                        className: "text-sm",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "mailto:contact@facture.art",
                                                className: "hover:underline",
                                                children: "contact@facture.art"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mb-10",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "mb-2 text-[#919191] uppercase",
                                        children: "Follow us"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                        className: "text-sm space-y-1.5",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "https://www.instagram.com/facture.art",
                                                target: "_blank",
                                                rel: "noreferrer",
                                                className: "hover:underline",
                                                children: "Instagram"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mb-10",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "mb-2 text-[#919191] uppercase",
                                        children: "Try us"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                        className: "text-sm space-y-1.5",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "https://wa.me/447787067215",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    className: "hover:underline",
                                                    children: "WhatsApp"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "https://t.me/facture_art_bot",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    className: "hover:underline",
                                                    children: "Telegram"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "text-[16px] md:hidden mt-20",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                children: "All artworks \xa9 the artists."
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                children: [
                                    "\xa9 ",
                                    new Date().getFullYear(),
                                    " All Rights Reserved. Artwishlist Ltd."
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
});


/***/ }),

/***/ 3619:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);



/* harmony default export */ __webpack_exports__["Z"] = ((param)=>{
    let { onMenuOpen , open  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "fixed top-0 left-0 min-h-full min-w-full ".concat(!open ? "hidden" : ""),
                style: {
                    background: "rgba(0,0,0,0.5)"
                },
                onClick: ()=>onMenuOpen()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("menu", {
                className: "flex fixed top-0 right-0 h-full text-white transition-transform duration-500",
                style: {
                    backgroundColor: "#262628",
                    width: 340,
                    transform: "translateX(".concat(open ? "0" : "100%", ")")
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-1 flex-col justify-between container mx-auto px-10 py-10 overflow-y-scroll",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    src: "/images/close.svg",
                                    alt: "Facture",
                                    width: "30",
                                    height: "30",
                                    className: "absolute right-5 cursor-pointer",
                                    onClick: ()=>onMenuOpen()
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/",
                                    onClick: ()=>onMenuOpen(),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                        src: "/images/facture-logo.svg",
                                        alt: "Facture",
                                        width: "453",
                                        height: "94",
                                        style: {
                                            width: "50%"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                    className: "my-10",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "mb-6 text-2xl",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/#artwork-timeline",
                                                onClick: ()=>onMenuOpen(),
                                                scroll: false,
                                                children: "Artwork Timeline"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "mb-6 text-2xl",
                                            onClick: ()=>onMenuOpen(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/#search",
                                                scroll: false,
                                                children: "Search"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "mb-6 text-2xl",
                                            onClick: ()=>onMenuOpen(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/#image-recognition",
                                                scroll: false,
                                                children: "Image recognition"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "mb-6 text-2xl",
                                            onClick: ()=>onMenuOpen(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                href: "/#editing",
                                                scroll: false,
                                                children: "Editing"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "mb-6 text-2xl",
                                            onClick: ()=>onMenuOpen(),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "mailto:contact@facture.art",
                                                children: "Contact"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "https://api.facture.art/login",
                                className: "button",
                                children: "Log in"
                            })
                        })
                    ]
                })
            })
        ]
    });
});


/***/ }),

/***/ 9183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/BusinessSection.tsx

/* harmony default export */ var BusinessSection = (()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "bg-cover bg-center bg-no-repeat overflow-hidden text-center",
        style: {
            backgroundColor: "#fff52c"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container mx-auto px-10 py-20 max-w-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-4xl font-normal mb-6",
                    children: "Are you a business?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:flex md:space-x-10 max-md:space-y-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 text-lg leading-[30px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                            className: "mb-6",
                            children: [
                                "If you are a business and would like to find out about our bespoke solutions or dedicated API access please",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "mailto:christian@facture.art?subject=Facture business solution enquiry",
                                    className: "underline",
                                    children: "get in touch"
                                }),
                                "."
                            ]
                        })
                    })
                })
            ]
        })
    });
});

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/EditingSection.tsx


/* harmony default export */ var EditingSection = (()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "flex overflow-hidden text-white",
        id: "editing",
        style: {
            backgroundColor: "#8d7455"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "mx-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "lg:flex lg:space-x-10 max-lg:space-y-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/catalogue-mobile.png",
                                width: "1369",
                                height: "1480",
                                alt: "",
                                className: "lg:hidden",
                                style: {
                                    marginBottom: "-30vw"
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/catalogue-desktop.png",
                                width: "1369",
                                height: "2192",
                                alt: "",
                                className: "max-lg:hidden"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-20 pr-24 max-lg:px-10",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "font-medium uppercase text-[15px] leading-[23px] md:text-[18px] md:leading-[26px] lg:text-[20px] lg:leading-[31px] mb-6",
                                        children: "4. Editing"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "font-normal text-[27px] leading-[31px] md:text-[30px] md:leading-[35px] lg:text-[40px] lg:leading-[46px] mb-6",
                                        children: "Take back control of art history authority."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex-1 text-lg leading-[30px]",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mb-6",
                                                children: "Supplement catalogue raisonn\xe9 data by adding a note, or view the comments and corrections submitted by a network of experts."
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mb-6",
                                                children: "On Facture, you can interact with others and improve the accuracy of a specific catalogue raisonn\xe9 entry, just by submitting a comment."
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/images/comments.png",
                                    width: "1512",
                                    height: "1610",
                                    alt: "",
                                    className: "mt-20"
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
});

// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(1082);
;// CONCATENATED MODULE: ./components/FeaturedSection.tsx


/* harmony default export */ var FeaturedSection = (()=>{
    const images = [
        {
            path: "/images/art-news-logo.jpg",
            title: "Art News",
            url: "https://www.artnews.com/art-news/sponsored-content/facture-debuts-1234596476/"
        },
        {
            path: "/images/handelsblatt-logo.svg",
            title: "Handelsblatt",
            url: "https://www.handelsblatt.com/arts_und_style/kunstmarkt/online-only-eine-neue-app-vereinfacht-das-geschaeft-mit-kunstauktionen-im-internet/25764510.html?ticket=ST-93141-sfmAq4XEtu3i9VDaGFWp-ap4"
        },
        {
            path: "/images/faz-logo.png",
            title: "Faz",
            url: "https://www.faz.net/aktuell/wirtschaft/unternehmen/christian-huhnt-der-kunst-nerd-18739626.html?fbclid=PAAabRdcR4etLnyXe2K9bEDn-lI55JfUMPGHvX5Wi-OiRJS4oOk184WipJVSk_aem_th_Ae7VIxngRlrbcEv49tLPxlwyRb9pnAFu1tw3dHe2pSsE01MVjTs1jXpP3OFVhC5xOhs"
        },
        {
            path: "/images/art-tactic-logo.png",
            title: "Art Tactic",
            url: "https://arttactic.com/podcast/christian-huhnt-glass/"
        }
    ];
    const imageStyles = {
        backgroundPosition: "center",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        display: "block",
        height: 100,
        width: 200
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container mx-auto px-10 pt-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-center text-base font-normal uppercase pb-6",
                    children: "Featured on"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative overflow-x-hidden pb-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "hover-pause",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "md:flex justify-center whitespace-nowrap",
                        children: images.map((image)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: image.url,
                                title: image.title,
                                target: "_blank",
                                rel: "noreferrer",
                                className: "mx-auto md:mx-10 hover:scale-125 transition-transform duration-300",
                                style: {
                                    backgroundImage: "url(".concat(image.path, ")"),
                                    ...imageStyles
                                }
                            }, image.path))
                    })
                })
            })
        ]
    });
});

// EXTERNAL MODULE: ./components/Footer.tsx
var Footer = __webpack_require__(4260);
;// CONCATENATED MODULE: ./components/HeroSection.tsx


/* harmony default export */ var HeroSection = ((param)=>{
    let { onMenuOpen  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "hero md:flex",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container mx-auto px-10 md:flex md:flex-1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-1 justify-between pt-10 lg:py-20",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col justify-between flex-1",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "/images/facture-logo.svg",
                                    alt: "Facture",
                                    width: "453",
                                    height: "94",
                                    style: {
                                        width: "80%",
                                        maxWidth: 453
                                    },
                                    className: "mb-5"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "max-md:hidden",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "text-5xl mb-10 text-[#fff52c]",
                                            children: "Setting the new standard for art research."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://search.facture.art/",
                                            className: "button button-sm mb-10",
                                            children: "Sign Up"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-start justify-end flex-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "/images/burger.svg",
                                alt: "Facture",
                                width: "55",
                                height: "22",
                                onClick: ()=>onMenuOpen(),
                                className: "pt-1 md:pt-3 max-md:max-w-[40px] cursor-pointer"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "md:hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-[20px] leading-[25px] md:text-5xl mb-5 md:mb-10 text-[#fff52c]",
                            children: "Setting the new standard for art research."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            href: "https://search.facture.art/",
                            className: "button button-sm mb-10",
                            children: "Sign Up"
                        })
                    ]
                })
            ]
        })
    });
});

;// CONCATENATED MODULE: ./constants/index.ts
const assetPath = "https://facture-landing-page-assets.s3.eu-west-2.amazonaws.com";

;// CONCATENATED MODULE: ./components/ImageRecognitionSection.tsx



/* harmony default export */ var ImageRecognitionSection = (()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "bg-cover bg-center bg-no-repeat overflow-hidden text-white",
        id: "image-recognition",
        style: {
            backgroundColor: "#3d3d3f"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container mx-auto px-10 py-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-medium uppercase text-[15px] leading-[23px] md:text-[18px] md:leading-[26px] lg:text-[20px] lg:leading-[31px] mb-6",
                        children: "3. Image recognition"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:flex md:space-x-10 max-md:space-y-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "font-normal text-[27px] leading-[31px] md:text-[30px] md:leading-[35px] lg:text-[40px] lg:leading-[46px]",
                                    children: "In a visual world you need visual search."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-1 text-lg leading-[30px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-6",
                                        children: "In an increasingly globalised world of different cultures and identities visual language becomes as important for communication as the written word."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-6",
                                        children: "Search any artwork with an illustration of that work by taking a photo or uploading a JPEG to receive the artwork details within seconds."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto px-10 pb-20",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/image-recognition.png",
                            width: "990",
                            height: "2412",
                            alt: "",
                            className: "md:hidden"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                            autoPlay: true,
                            playsInline: true,
                            loop: true,
                            muted: true,
                            className: "max-md:hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: "".concat(assetPath, "/video/image-recognition.mp4"),
                                    type: "video/mp4"
                                }),
                                "Your browser does not support the video tag."
                            ]
                        })
                    ]
                })
            })
        ]
    });
});

// EXTERNAL MODULE: ./components/Menu.tsx
var Menu = __webpack_require__(3619);
;// CONCATENATED MODULE: ./components/NumbersSection.tsx

/* harmony default export */ var NumbersSection = (()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "flex bg-cover bg-center bg-no-repeat text-white text-center",
        style: {
            backgroundImage: "url(/images/warehouse.jpg)"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex relative absolute top-0 flex-1",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-1",
                style: {
                    backgroundColor: "rgba(0,0,0,0.8)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container mx-auto px-10 py-40 flex flex-col flex-1 justify-center items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-[30px] leading-[35px] md:text-[52px] mb-10",
                            children: "Facture in Numbers"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-[20px] leading-[28px] md:text-2xl font-normal max-w-xl mb-10",
                            children: "Gain access to the world's most diverse and comprehensive art database"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "xl:flex text-center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex-1 mx-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-[30px] leading-[35px] md:text-[42px] font-bold border-b py-4 my-4 md:py-8 md:my-8",
                                            style: {
                                                borderColor: "rgba(255,255,255,0.2)"
                                            },
                                            children: "675,000+"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[14px] md:text-lg",
                                            children: "Artists"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex-1 mx-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-[30px] leading-[35px] md:text-[42px] font-bold border-b py-4 my-4 md:py-8 md:my-8",
                                            style: {
                                                borderColor: "rgba(255,255,255,0.2)"
                                            },
                                            children: "13 million+"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[14px] md:text-lg",
                                            children: "Auction records from 100,000 auction houses going back half a century"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex-1 mx-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-[30px] leading-[35px] md:text-[42px] font-bold border-b py-4 my-4 md:py-8 md:my-8",
                                            style: {
                                                borderColor: "rgba(255,255,255,0.2)"
                                            },
                                            children: "35,000+"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[14px] md:text-lg",
                                            children: "Private and public art collections"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex-1 mx-5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: "text-[30px] leading-[35px] md:text-[42px] font-bold border-b py-4 my-4 md:py-8 md:my-8",
                                            style: {
                                                borderColor: "rgba(255,255,255,0.2)"
                                            },
                                            children: "2 million+"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-[14px] md:text-lg",
                                            children: "Artworks from Museums worldwide"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
});

;// CONCATENATED MODULE: ./components/SearchSection.tsx


/* harmony default export */ var SearchSection = (()=>{
    const row1 = [
        {
            image: "/images/search-image-christies.png",
            source: "/images/search-logo-christies.png",
            title: "Eduardo Chillida (1924-2002)\nElogio de la arquitectura IV, Executed in 1974",
            description: "Alabaster\n15 \xd7 17 \xd7 16cm\n\nSold at Chrstie's, London\nLive Auction 1106\nPost-War and Contemporary Art (Evening Auction)\n13 February 2013"
        },
        {
            image: "/images/search-image-artsy.png",
            source: "/images/search-logo-artsy.png",
            title: "Vanessa Beecroft\nMiki Alabaster, 2012",
            description: "White alabaster marble\n195 \xd7 34.5 \xd7 48 cm\n\nCourtesy of Lia Rumma\nMilan /Napoli"
        },
        {
            image: "/images/search-image-wallace.png",
            source: "/images/search-logo-wallace.png",
            title: "Unknown Artist / Maker\nThe Resurrection, 15th century",
            description: "Alabaster, gilded and painted\n44.5 \xd7 27.9 cm\n\nThe Wallace Collection, London"
        },
        {
            image: "/images/search-image-phillips.png",
            source: "/images/search-logo-phillips.png",
            title: "Sterling Ruby\nAlabaster Centrifugal #1, 2007",
            description: "Acrylic, in artist's frame\n124.8 \xd7 124.8 cm\n\nSold at Phillips, New York\n20th Century & Contemporary Art Day Sale,\n16 May 2018"
        }
    ];
    const row2 = [
        {
            image: "/images/search-image-kunst.png",
            source: "/images/search-logo-kunst.png",
            title: "Gesichtsstele\nKopf 2. - 1. Jh. v. Chr.",
            description: "Alabaster\nH 20,5 cm, B 10,5 cm, T 6 cm\n\nKunsthistorisches Museum, Wien"
        },
        {
            image: "/images/search-image-ketterer.png",
            source: "/images/search-logo-ketterer.png",
            title: "Louise Bourgeois\nCunt l/ Untitled (Femme), 1969/70",
            description: "Rosa Alabaster\n17 \xd7 7 \xd7 5 cm\n\nSold at Ketterer Kunst, Munich\nSale: 437 / Post War |\n10 December 2016"
        },
        {
            image: "/images/search-image-met.png",
            source: "/images/search-logo-met.png",
            title: "Alabaster alabastron\n(perfume vase), 5th-4th century B.C.",
            description: "Gypsum (alabaster)\n13.3 \xd7 4.4 cm\n\nThe Metropolitan Museum of Art,\nNew York"
        },
        {
            image: "/images/search-image-catrais.png",
            source: "/images/search-logo-catrais.png",
            title: 'Alberto Giacometti\nPair of "Le Poing" Sconces\ndesigned circa 1935',
            description: "gilt bronze, alabaster\n28.89 \xd7 14.29 \xd7 22.86 cm\n\nCat. No: AGD 4157\n\nPrivate Collection"
        },
        {
            image: "/images/search-image-artnet.png",
            source: "/images/search-logo-artnet.png",
            title: "Rick Owens\nHalf Box, 2011",
            description: "Half Box (Alabaster), 2011\nSculpture\n77 \xd7 50 \xd7 50 cm\nLimited Edition of 8 + 4 AP\n\nCourtesy of Carpenters\nWorkshop Gallery\nParis, New York, London, San Francisco"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "bg-cover bg-center bg-no-repeat overflow-hidden",
        id: "search",
        style: {
            backgroundColor: "#fff52c",
            height: 1600
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container mx-auto px-10 py-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-medium uppercase text-[15px] leading-[23px] md:text-[18px] md:leading-[26px] lg:text-[20px] lg:leading-[31px] mb-6",
                        children: "2. Search"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:flex md:space-x-20 max-md:space-y-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "font-normal text-[27px] leading-[31px] md:text-[30px] md:leading-[35px] lg:text-[40px] lg:leading-[46px]",
                                    children: "Elevate your curatorial practice onto another level."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1 text-lg leading-[30px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "Deepen your knowledge and capabilities with an agnostic search functionality that goes beyond an artist's name or an auction house. Search entire private collections, past important exhibitions or a specific material for an overview of art historic exceptionalism that is second to none."
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col justify-center items-center mx-5 md:mx-10",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/search-input.svg",
                        alt: "",
                        width: "683",
                        height: "123",
                        className: "my-10"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-xl text-center font-normal uppercase my-5",
                        children: "Search results:"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "container md:px-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid grid-cols-2 md:grid-cols-6 lg:grid-cols-10 gap-10 md:gap-20",
                                children: row1.map((card, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "my-4 md:my-10 md:col-span-2 lg:col-span-3 ".concat([
                                            1,
                                            2
                                        ].some((n)=>n === i) && "lg:col-span-2", " ").concat(i === 3 && "sm:block md:hidden lg:block"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: card.image,
                                                height: "100",
                                                width: "100",
                                                alt: card.title,
                                                style: {
                                                    width: "100%",
                                                    maxHeight: 250
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "bg-contain bg-left bg-no-repeat my-4 md:my-6",
                                                style: {
                                                    backgroundImage: "url(".concat(card.source, ")"),
                                                    height: 30,
                                                    width: 100
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xs mb-4 whitespace-pre-wrap",
                                                children: card.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xs whitespace-pre-wrap",
                                                style: {
                                                    opacity: 0.6
                                                },
                                                children: card.description
                                            })
                                        ]
                                    }, card.title))
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "grid grid-cols-2 md:grid-cols-10 gap-10",
                                children: row2.map((card)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "my-10 md:col-span-2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: card.image,
                                                height: "100",
                                                width: "100",
                                                alt: card.title,
                                                style: {
                                                    width: "100%",
                                                    maxHeight: 250
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "bg-contain bg-left bg-no-repeat my-4 md:my-6",
                                                style: {
                                                    backgroundImage: "url(".concat(card.source, ")"),
                                                    height: 30,
                                                    width: 120
                                                }
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xs mb-4 whitespace-pre-wrap",
                                                children: card.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "text-xs whitespace-pre-wrap",
                                                style: {
                                                    opacity: 0.6
                                                },
                                                children: card.description
                                            })
                                        ]
                                    }, card.title))
                            })
                        ]
                    })
                ]
            })
        ]
    });
});

// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 39 modules
var axios = __webpack_require__(594);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(2920);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/SignupForm.tsx





/* harmony default export */ var SignupForm = (()=>{
    const [emailAddress, setEmailAddress] = (0,react.useState)("");
    const [loading, setLoading] = (0,react.useState)(false);
    const [consent, setConsent] = (0,react.useState)(false);
    const [valid, setValid] = (0,react.useState)(false);
    const validateEmail = (email)=>{
        return String(email).toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    };
    const subscribe = async ()=>{
        try {
            setLoading(true);
            if (!emailAddress) {
                throw new Error("No email address provided");
            }
            if (!consent) {
                throw new Error("Consent not provided");
            }
            if (!validateEmail(emailAddress)) {
                throw new Error("Invalid email address");
            }
            const res = await axios/* default.put */.Z.put("/api/signup", {
                mail: emailAddress
            });
            if (res.status === 200) {
                react_toastify_esm/* toast.success */.Am.success(res.data.message);
                setEmailAddress("");
                setLoading(false);
            }
        } catch (error) {
            if (error instanceof Error) {
                if (error.message === "No email address provided") {
                    return react_toastify_esm/* toast.error */.Am.error("Oops, you didn't enter an email address!");
                }
                if (error.message === "Consent not provided") {
                    return react_toastify_esm/* toast.error */.Am.error("Oops, you didn't check the consent checkbox!");
                }
                if (error.message === "Invalid email address") {
                    return react_toastify_esm/* toast.error */.Am.error("Oops, you didn't enter a valid email address!");
                }
            }
            return react_toastify_esm/* toast.error */.Am.error("Oops, there was a problem with your subscription, please try again or contact us");
        } finally{
            setLoading(false);
        }
    };
    (0,react.useEffect)(()=>{
        setValid(consent && !!validateEmail(emailAddress));
    }, [
        consent,
        emailAddress
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: "my-10 md:flex justify-center items-center",
                onSubmit: (e)=>e.preventDefault(),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        onChange: (e)=>{
                            setEmailAddress(e.target.value);
                        },
                        type: "email",
                        placeholder: "Email address*",
                        className: "input input-primary input-bordered max-md:mb-5",
                        value: emailAddress
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: subscribe,
                        className: "button button-dark button-small btn ml-3 ".concat(loading ? "btn-disabled loading" : "btn-primary", " disabled:opacity-10"),
                        disabled: !valid,
                        children: loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            role: "status",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    "aria-hidden": "true",
                                    className: "m-auto w-6 h-6 animate-spin",
                                    viewBox: "0 0 100 101",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
                                        fill: "currentColor"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sr-only",
                                    children: "Loading..."
                                })
                            ]
                        }) : "Sign up"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "md:flex md:space-x-10 max-md:space-y-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex-1 text-lg leading-[30px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center mb-4 align-start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-start mr-4 mb-2",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "checkbox",
                                        id: "consent",
                                        className: "opacity-0 absolute h-6 w-6",
                                        onChange: (event)=>{
                                            setConsent(event.target.checked);
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-transparent border-2 rounded-md border-black w-6 h-6 flex flex-shrink-0 justify-center items-center mr-2 focus-within:border-black",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            className: "fill-current hidden w-3 h-3 text-black pointer-events-none",
                                            version: "1.1",
                                            viewBox: "0 0 17 12",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                fill: "none",
                                                fillRule: "evenodd",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                                                    transform: "translate(-9 -11)",
                                                    fill: "#000",
                                                    fillRule: "nonzero",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "m25.576 11.414c0.56558 0.55188 0.56558 1.4439 0 1.9961l-9.404 9.176c-0.28213 0.27529-0.65247 0.41385-1.0228 0.41385-0.37034 0-0.74068-0.13855-1.0228-0.41385l-4.7019-4.588c-0.56584-0.55188-0.56584-1.4442 0-1.9961 0.56558-0.55214 1.4798-0.55214 2.0456 0l3.679 3.5899 8.3812-8.1779c0.56558-0.55214 1.4798-0.55214 2.0456 0z"
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        htmlFor: "consent",
                                        className: "select-none",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-xs mb-6",
                                            children: [
                                                "By clicking to sign up you provide your consent to sign up to Facture.art's newsletter and will be the first to know of new features, artists and pricing options on Facture. For more information about how we use your personal data, please see our",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: "/privacy-policy",
                                                    title: "Privacy Policy",
                                                    className: "underline",
                                                    children: "Privacy Policy"
                                                }),
                                                "."
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-xs",
                            children: 'You can unsubscribe from our newsletters at any time by clicking the "unsubscribe" option at the bottom of any of our newsletters.'
                        })
                    ]
                })
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/StayInTouchSection.tsx


/* harmony default export */ var StayInTouchSection = (()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "bg-cover bg-center bg-no-repeat overflow-hidden text-center",
        id: "signup",
        style: {
            backgroundColor: "#fff52c"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container mx-auto px-10 py-20 max-w-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-4xl font-medium mb-6",
                    children: "Stay in touch"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:flex md:space-x-10 max-md:space-y-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex-1 text-lg leading-[30px]",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            children: "Sign up for our newsletter and be the first to know of new features, artists and pricing options on Facture."
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SignupForm, {})
            ]
        })
    });
});

;// CONCATENATED MODULE: ./components/TimelineSection.tsx



/* harmony default export */ var TimelineSection = (()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "bg-cover bg-center bg-no-repeat overflow-hidden",
        id: "artwork-timeline",
        style: {
            backgroundColor: "#f3f3f3"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container mx-auto px-10 py-20",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "font-medium uppercase text-[15px] leading-[23px] md:text-[18px] md:leading-[26px] lg:text-[20px] lg:leading-[31px] mb-6",
                        children: "1. Artwork Timeline"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "md:flex md:space-x-10 max-md:space-y-10",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex-1",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                    className: "font-normal text-[27px] leading-[31px] md:text-[30px] md:leading-[35px] lg:text-[40px] lg:leading-[46px]",
                                    children: [
                                        "Catalogue Raisonn\xe9, auction prices, exhibition history:",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "All in one place with the artwork timeline."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex-1 text-lg leading-[30px]",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-6",
                                        children: 'Starting in 2016 over the course of five years we meticulously digitised and reorganised hundreds of catalogues raisonn\xe9s, important monographs and exhibition catalogues of the world\'s most visible artists to bring what is generally referred to as a "price database" into the 21st Century.'
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Welcome to the future of online, aggregated and always in itself updating catalogues raisonn\xe9s."
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-white flex flex-col justify-center items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/timeline-search.svg",
                        alt: "",
                        width: "1443",
                        height: "62",
                        className: "my-8 ml-80 md:ml-40 min-w-[150%] md:min-w-full"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        src: "/images/timeline-card.svg",
                        alt: "",
                        width: "414",
                        height: "170",
                        className: "p-10"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        style: {
                            top: 2,
                            position: "relative"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("video", {
                            autoPlay: true,
                            playsInline: true,
                            loop: true,
                            muted: true,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                    src: "".concat(assetPath, "/video/timeline.mp4"),
                                    type: "video/mp4"
                                }),
                                "Your browser does not support the video tag."
                            ]
                        })
                    })
                ]
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/TrustedSection.tsx
// import Image from 'next/image';


/* harmony default export */ var TrustedSection = (()=>{
    const images = [
        {
            path: "/images/vanham-logo.png",
            title: "Van Ham",
            url: "https://www.van-ham.com/"
        },
        {
            path: "/images/gagosian-logo.png",
            title: "Gagosian",
            url: "https://gagosian.com/"
        },
        {
            path: "/images/va-logo.png",
            title: "V&A",
            url: "https://www.vam.ac.uk/"
        },
        {
            path: "/images/koller-logo.svg",
            title: "Koller",
            url: "https://www.kollerauktionen.ch/"
        },
        {
            path: "/images/artsy-logo.png",
            title: "Artsy",
            url: "https://www.artsy.net/"
        },
        {
            path: "/images/casa-daste-capitolium-art-logo.png",
            title: "Capitolium Art",
            url: "https://www.capitoliumart.it/en"
        },
        {
            path: "/images/blomqvist-logo.png",
            title: "Blomqvist",
            url: "https://www.blomqvist.no/"
        },
        {
            path: "/images/heritage-logo.png",
            title: "Heritage Auctions",
            url: "https://www.ha.com/"
        },
        {
            path: "/images/trinity-logo.png",
            title: "Trinity House Paintings",
            url: "https://www.trinityhousepaintings.com/"
        },
        {
            path: "/images/hauser-and-wirth-logo.png",
            title: "Hauser & Wirth",
            url: "https://www.hauserwirth.com/"
        },
        {
            path: "/images/phillips-logo.png",
            title: "Phillips",
            url: "https://www.phillips.com/"
        },
        {
            path: "/images/xavier-hufkens-logo.png",
            title: "Xavier Hufkens",
            url: "https://www.xavierhufkens.com/"
        },
        {
            path: "/images/colnaghi-logo.png",
            title: "Colnaghi",
            url: "https://www.colnaghi.com/"
        },
        {
            path: "/images/bassenge-logo.png",
            title: "Bassenge",
            url: "https://bassenge.com/"
        },
        {
            path: "/images/dickinson-logo.png",
            title: "Simon Dickinson",
            url: "https://www.simondickinson.com/"
        },
        {
            path: "/images/hollis-logo.png",
            title: "Hollis Uaggart",
            url: "https://www.hollistaggart.com/"
        },
        {
            path: "/images/gagosian-art-advisory-logo.png",
            title: "Gagosian Art Advisory",
            url: "https://gagosianartadvisory.com/"
        },
        {
            path: "/images/benuri-logo.png",
            title: "Benuri",
            url: "https://benuri.org/"
        },
        {
            path: "/images/hindman-logo.png",
            title: "Hindman Auctions",
            url: "https://hindmanauctions.com/"
        },
        {
            path: "/images/mg-logo.png",
            title: "The Matthews Gallery",
            url: "https://www.thematthewsgallery.com/"
        }
    ];
    const imageStyles = {
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        display: "block",
        height: 120,
        width: 220
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container mx-auto px-10 pt-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "text-center text-base font-normal uppercase pb-6",
                    children: "Trusted by"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative overflow-x-hidden pb-12",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "hover-pause",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex animate-marquee whitespace-nowrap",
                            style: {
                                width: images.length * 220
                            },
                            children: images.map((image)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: image.url,
                                    title: image.title,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    className: "hover:scale-125 transition-transform duration-300",
                                    style: {
                                        backgroundImage: "url(".concat(image.path, ")"),
                                        ...imageStyles
                                    }
                                }, image.path))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex absolute top-0 animate-marquee2 whitespace-nowrap",
                            style: {
                                width: images.length * 220
                            },
                            children: images.map((image)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: image.url,
                                    title: image.title,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    className: "hover:scale-125 transition-transform duration-300",
                                    style: {
                                        backgroundImage: "url(".concat(image.path, ")"),
                                        ...imageStyles
                                    }
                                }, image.path))
                        })
                    ]
                })
            })
        ]
    });
});

;// CONCATENATED MODULE: ./components/WhatsappSection.tsx


/* harmony default export */ var WhatsappSection = (()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "bg-cover bg-center bg-no-repeat overflow-hidden text-white text-center",
        style: {
            backgroundColor: "#3d3d3f"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "container mx-auto px-10 py-20 max-w-xl",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                    className: "text-4xl font-normal mb-6",
                    children: "Or why don't you try it out?"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "md:flex md:space-x-10 max-md:space-y-10",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-1 text-lg leading-[30px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mb-6",
                                children: "Try out our state-of-the-art image recognition technology on WhatsApp, free of charge for a week!"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: "mb-6",
                                children: [
                                    "Simply",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "https://wa.me/447787067215",
                                        className: "underline",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        children: "follow this link"
                                    }),
                                    " ",
                                    "and get started."
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://wa.me/447787067215",
                        target: "_blank",
                        rel: "noreferrer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: "/images/whatsapp.png",
                            alt: "Facture Whatsapp",
                            width: "46",
                            height: "46",
                            className: "m-auto"
                        })
                    })
                })
            ]
        })
    });
});

;// CONCATENATED MODULE: ./pages/index.tsx
















const Index = ()=>{
    const [menuOpen, setMenuOpen] = (0,react.useState)(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Facture: Catalogues Raisonn\xe9s as a Subscription"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroSection, {
                        onMenuOpen: ()=>setMenuOpen(!menuOpen)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TrustedSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NumbersSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageRecognitionSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EditingSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StayInTouchSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsappSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BusinessSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Menu/* default */.Z, {
                        onMenuOpen: ()=>setMenuOpen(!menuOpen),
                        open: menuOpen
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages = (Index);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [247,464,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);